import React, {useContext, useEffect, useState} from 'react'
import BackDrop from "../../UI/backdrop/Backdrop";
import SigningForm from "../../components/signingForm/SigningForm";
import PdfDocument from "../../components/pdfDocument/PdfDocument";
import MetaTags from "../../components/metaTags/MetaTags";
import API from "../../adapters/API";


const Main = (props) => {

    const [loading, setLoading] = useState(true);
    const [pdfBlob, setPdfBlob] = useState(null);
    const [documentNotFound, setDocumentNotFound] = useState(false);
    const [code, setCode] = useState("")
    const [currentIp, setCurrentIp] = useState(null)
    const [browserWidth, setBrowserWidth] = useState(document.body.clientWidth)
    const [signed, SetSigned] = useState(false)


    window.addEventListener("resize", () => {
        setBrowserWidth(document.body.clientWidth)
    })

    const onSign = () => {
        SetSigned(true)
    }
    const getPdf = async (code) => {
        const config = {
            responseType: 'blob'
        }
        return await API.get(`document/${code}`, config)
    }

    useEffect(() => {
            const query = new URLSearchParams(document.location.search);
            const code = query.get('code')
            setCode(code)

            async function FetchPdf(code) {
                try {
                    const pdfResp = await getPdf(code)
                    const blobPDF = pdfResp.data
                    setPdfBlob(blobPDF)


                } catch (e) {
                    if (e.response.status === 404) {
                        setDocumentNotFound(true)
                    } else {
                        throw e
                    }
                }
                setLoading(false)

            }

            FetchPdf(code).then(() => {
                API.get('ip').then((res) => {
                    console.log('get ip')
                    setCurrentIp(res.data.ip)
                });
            })

        }, []
    )


    return (
        <React.Fragment>
            <MetaTags/>
            {documentNotFound ?
                <div>
                    <h1>Document not found or was already signed</h1>
                </div>:
                signed ?
                    <div>
                        <h1>Document was successfully signed</h1>
                    </div>
                    :
                    loading ?
                        <BackDrop open={true}/> :

                        <div style={{width: 'fill-available', position: 'relative'}}>
                            <PdfDocument
                                pdfBlob={pdfBlob}
                                code={code}
                                browserWidth={browserWidth}
                            />
                            <SigningForm onSign={onSign} browserWidth={browserWidth} pdfBlob={pdfBlob} code={code}
                                         ip={currentIp}/>
                        </div>


            }

        </React.Fragment>
    )

}

export default Main